/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getTokenExpirySeconds } from 'modules/common/helpers/jwt';
import { selectAccessToken } from 'modules/common/auth/selectors';
import TIME_OUTS from 'modules/common/constants/time-outs';
/**
 * Based on the access token expiration check the token expired or not
 * @returns
 */
const useIsTokenValid = () => {
  /* Determine if authorized, from context or however you're doing it */
  const accessToken = useSelector(selectAccessToken);
  //
  const isValid = useCallback(() => {
    if (accessToken) {
      const exp = getTokenExpirySeconds(accessToken);
      return exp !== null && exp >= Date.now() / 1000;
    }
    return false;
  }, [accessToken]);

  const doNeedRefresh = useCallback((candidateAccessToken) => {
    if (candidateAccessToken) {
      const exp = getTokenExpirySeconds(candidateAccessToken);
      //
      return exp === null || exp <= Date.now() / 1000 + TIME_OUTS.ACCESS_TOKEN_REFRESH_LEEWAY;
    }
    return false;
  }, []);

  return { isValid, doNeedRefresh };
};
//
export default useIsTokenValid;
